export const formatFullName = (name?: string, last_name?: string) => {
  return `${last_name}, ${name}`;
};
